import React from 'react';
import SertifAlgeo from '../../assets/Sertif_Algeo.pdf';
import SertifStima from '../../assets/Sertif_Stima.pdf';
import SertifProbstat from '../../assets/Sertif_Probstat.pdf';
import SertifikatACL2025 from "../../assets/SertifikatACL2025.pdf";
import SentiLab from '../../assets/SentiLab_Copyright.pdf';

interface NewsItemTitleProps {
    date: string;
}

const NewsItemTitle: React.FC<NewsItemTitleProps> = ({ date }) => {
    switch (date) {
        case '2025.08':
            return (
                <React.Fragment>
                    2 of my papers : <a className="text-textRed font-medium hover:underline" href="https://arxiv.org/abs/2601.17277">Ping-Pong</a> (First Author) are accepted to EMNLP-Main Conference and <a className="text-textRed font-medium hover:underline" href="https://arxiv.org/abs/2505.13388">R3</a> are accepted to TMLR.
                </React.Fragment>
            );
        case '2025.05':
            return (
                <React.Fragment>
                    Two papers: <a className="text-textRed font-medium hover:underline" href="https://arxiv.org/pdf/2502.20864">Javanese Honorifics</a> (First Author) and <a className="text-textRed font-medium hover:underline" href="https://arxiv.org/pdf/2503.07920">SEA-VL</a> (Major Contributor)—accepted to <a className="text-textRed hover:underline" href={SertifikatACL2025}><b>ACL 2025</b></a> (Main Conference) during my undergrad (covered by <a className="text-textRed font-medium hover:underline" href="https://www.capitalone.com/tech/ai/acl-2025/?msockid=321993d58b986f3f28f283cf8a136e7f">Capital One</a>)! See you in Vienna!
                </React.Fragment>
            );
        case '2025.04':
            return (
                <React.Fragment>
                    Started my Research Assistantship with <a className="text-textRed font-medium hover:underline" href="https://www.monash.edu/indonesia/our-research/data-democracy-research-hub">Monash University's Data and Democracy Research Group</a>
                </React.Fragment>
            );
        case '2025.01':
            return (
                <React.Fragment>
                    Our work, <a className="text-textRed font-medium hover:underline" href={SentiLab}>SentiLab-LLM</a>, is officially registered as a copyrighted work by Indonesia's Ministry of Law
                </React.Fragment>
            );
        case '2024.09':
            return (
                <React.Fragment>
                    My undergraduate thesis will be affiliated with <a className="text-textRed font-medium hover:underline" href="https://mbzuai.ac.ae/">MBZUAI</a>
                </React.Fragment>
            );
        case '2023.12':
            return (
                <React.Fragment>
                    Joined Garuda ACE Lab remotely with <a className="text-textRed font-medium hover:underline" href="https://www.bu.edu/">Boston University!</a>
                </React.Fragment>
            );
        case '2023.08':
            return (
                <React.Fragment>
                    Appointed as a Teaching Assistant for <a className="text-textRed font-medium hover:underline" href={SertifAlgeo}>Linear Algebra and Geometry</a>; <a className="text-textRed font-medium hover:underline" href={SertifStima}>Algorithm Strategies</a>; and <a className="text-textRed font-medium hover:underline" href={SertifProbstat}>Probability and Statistics</a> at ITB :D
                </React.Fragment>
            );
        case '2023.04':
            return (
                <React.Fragment>
                    Received travel grant to attend Singapore Amazing Flying Machine Competition (<a className="text-textRed font-medium hover:underline" href="https://www.safmc.com.sg/">SAFMC</a>)
                </React.Fragment>
            );
        case '2022.08':
            return (
                <React.Fragment>
                    Got <a className="text-textRed font-medium hover:underline" href="">my first Teaching Assistant opportunity</a> in USDI, ITB.
                </React.Fragment>
            );
        case '2021.08':
            return (
                <React.Fragment>
                    Started my Bachelor journey in Institut Teknologi Bandung.
                </React.Fragment>
            );
        default:
            return null;
    }
};

export default NewsItemTitle;